import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import CrossedCircle from '@factorialco/f0-react/icons/app/CrossedCircle'
import type {
  EmployeePayrollRunElementInputEmployeePayrollRunCompensationFragment,
} from 'generated/resources/graphql'

type IntegrationsSyncableErrorMessages =
  NonNullable<
    EmployeePayrollRunElementInputEmployeePayrollRunCompensationFragment['syncableState']
  >[number]['errorMessages'][number]

import i18n from 'modules/core/lib/i18n'

import { labelMargin } from './index.vanilla.css'

interface FailedLabelProps {
  errorMessages: Array<IntegrationsSyncableErrorMessages>
}

export const FailedLabel = ({ errorMessages }: FailedLabelProps) => {
  const formattedErrorMessage = errorMessages
    .map((error) => error.value)
    .filter(Boolean)
    .join(', ')

  return (
    <Box flexDirection="row" gap="s2" justifyContent="flexEnd" alignItems="center">
      <Text.Normal color="radicalRed800" size="100">
        <F0Icon icon={CrossedCircle} type="warning" />
      </Text.Normal>
      <Text.Normal color="radicalRed1500" size="100" className={labelMargin}>
        {formattedErrorMessage
          ? `${i18n.t('integrations.syncable_status.failed')}. ${formattedErrorMessage}`
          : i18n.t('integrations.syncable_status.failed')}
      </Text.Normal>
    </Box>
  )
}
